import { render, staticRenderFns } from "./productOrderContract.vue?vue&type=template&id=60f3832a&"
import script from "./productOrderContract.vue?vue&type=script&lang=js&"
export * from "./productOrderContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports